var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-digital-mlpa-main-page col-block width-full"},[(_vm.projectID.startsWith('date-'))?[_c('mainUpload',{on:{"create":function (data) { return _vm.$emit('create', data); }}})]:[_c('mainData',{attrs:{"projects":_vm.projects,"projectID":_vm.projectID}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aed304c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalMLPA/main.vue
// module id = null
// module chunks = 